const a = "_avatar_1kfd4_1", t = {
  avatar: a
};
export {
  a as avatar,
  t as default
};
